import {Module} from "vuex-smart-module";
import AccessControlState from "@/store/modules/access-control/access-control-state";
import AccessControlGetters from "@/store/modules/access-control/access-control-getters";
import AccessControlMutations from "@/store/modules/access-control/access-control-mutations";
import AccessControlActions from "@/store/modules/access-control/access-control-actions";

export default new Module({
    state: AccessControlState,
    getters: AccessControlGetters,
    mutations: AccessControlMutations,
    actions: AccessControlActions
});
